import { render, staticRenderFns } from "./ValidateQuestion.vue?vue&type=template&id=429b0db8&scoped=true&"
import script from "./ValidateQuestion.vue?vue&type=script&lang=js&"
export * from "./ValidateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ValidateQuestion.vue?vue&type=style&index=0&id=429b0db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429b0db8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
